import { z } from 'zod'

/** 企業帳號 - 新增企業帳號 Response Schema */
export const corporateAccountCreateResponseSchema = z.object({
  /** 企業帳號 */
  account: z.string()
})

/** 企業帳號 - 新增企業帳號 Response */
export interface CorporateAccountCreateResponse
  extends z.infer<typeof corporateAccountCreateResponseSchema> {}
